'use client';

import { useRouter } from '@shared/hooks/use-router';
import { APP_ROUTES } from '@/shared/constants/navigation';
import { COPY } from '@/shared/constants/copies';
import PageErrorState from '@/shared/components/page-error-state';

function FormNotFoundPage() {
	const router = useRouter();

	return (
		<main className="flex h-screen flex-col items-center justify-center">
			<PageErrorState
				title="Page not found"
				description="Sorry, the page you are looking for doesn't exist, or has been moved."
				actionLabel={COPY.access.goHomeCta}
				onAction={() => router.push(APP_ROUTES.ROOT)}
			/>
		</main>
	);
}

export default FormNotFoundPage;
